import React from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import accessDeniedImage from '../app/webcomponents/assets/images/empty-states_illustration_access_denied.svg';
import logOutImage from '../app/webcomponents/assets/images/empty-states_illustration_first-use.svg';
import '../assets/css/Unauthorized.css';

const Unauthorized = () => {
    const { state } = useLocation();
    const [searchParams] = useSearchParams();
    const hasTenantResetParam = searchParams.has("isTenantReset");
    const hasDisableWorkflowParam = searchParams.has("issueDisableWorkflow");
    const isTenantReset = hasTenantResetParam ? searchParams.get("isTenantReset") : null;
    const hasIssueDisableWorkflow = hasDisableWorkflowParam ? searchParams.get("issueDisableWorkflow") : null;

    const handleVsaRedirection = () => {
        if (state?.authorizeUrl !== undefined && state?.authorizeUrl !== '') {
            window.location.href = state?.authorizeUrl;
        }
        if (state?.tenantUrl !== undefined && state?.tenantUrl !== '') {
            window.location.href = `${state?.tenantUrl}/app/main/integrations/bitdefender`;
        }
    }

    if (hasIssueDisableWorkflow !== null && hasIssueDisableWorkflow !== undefined && Boolean(hasIssueDisableWorkflow)) {
        return (
            <div className='flex flex-col items-center justify-center center-div'>
                <img width={200} height={171} src={logOutImage} alt="401 - Unauthorized" />
                <h2 className='pb-3 mt-2 text-lg font-semibold' >Logged out</h2>
                <h2 className='pb-3' >The 'Bitdefender - Disable Policies Workflow' could not be found or an issue occurred while running it.<br />
                    This step is required for the process of disabling the old Bitdefender integration.<br /><br />
                    Please contact <a href="https://www.bitdefender.com/business/support/en/71263-85158-contact.html"><u>Bitdefender Enterprise Support</u></a> for further assistance.
                </h2>
            </div>
        )
    }

    if (isTenantReset !== null && isTenantReset !== undefined && Boolean(isTenantReset)) {
        return (
            <div className='flex flex-col items-center justify-center center-div'>
                <img width={200} height={171} src={logOutImage} alt="401 - Unauthorized" />
                <h2 className='pb-3 mt-2 text-lg font-semibold' >Logged out</h2>
                <h2 className='pb-3' >Your Bitdefender VSA X integration is disabled.<br /> To enable it, contact your Kaseya VSA X administrator.</h2>
            </div>
        )
    }

    if (state?.authorizeUrl !== undefined && state?.authorizeUrl !== '') {
        return (
            <div className='flex flex-col items-center justify-center center-div'>
                <img width={200} height={171} src={logOutImage} alt="401 - Unauthorized" />
                <h2 className='pb-3 mt-2 text-lg font-semibold' >Logged out</h2>
                <h2 className='pb-3' >Your corresponding VSA X token is no longer valid. <br /> Use the reauthorize button to regenerate it.</h2>
                <gz-button onClick={handleVsaRedirection} id="goToVsaxButton" type="full" color="primary">REAUTHORIZE</gz-button>
            </div>
        )
    }

    if (state?.isSignOut === null || state?.isSignOut === undefined || state?.isSignOut === false) {
        return (
            <div className='flex flex-col items-center justify-center center-div'>
                <img width={200} height={171} src={accessDeniedImage} alt="401 - Unauthorized" />
                <h2 className='pb-3 text-lg font-semibold' >401 - Unauthorized</h2>
                <h2 className='pb-3' >Please log in to the Bitdefender app using <br /> the Kaseya VSA X platform.</h2>
            </div>
        )
    }

    return (
        <div className='flex flex-col items-center justify-center center-div'>
            <img width={200} height={171} src={logOutImage} alt="401 - Unauthorized" />
            <h2 className='pb-3 mt-2 text-lg font-semibold' >Logged out</h2>
            <h2 className='pb-3' >You can log in to the Bitdefender app using <br /> the Kaseya VSA X platform.</h2>
            <gz-button onClick={handleVsaRedirection} id="goToVsaxButton" type="full" color="primary">Log in</gz-button>
        </div>
    )
}

export default Unauthorized;